<template>
  <IndexBlok :id="7"></IndexBlok>
</template>

<script>

    import IndexBlok from "../../components/Doc/IndexBlok";

    export default {
        components: {IndexBlok},
        data() {
            return {}
        },
        methods: {},
        created() {
            window.addEventListener('keyup', event => {
                //if (event.key === "1") router.push("/yonetim/sirket");
                //if (event.key === "2") router.push("/yonetim/site");
                //if (event.key === "3") router.push("/yonetim/bina");
                //if (event.key === "4") router.push("/yonetim/mesken");
                //if (event.key === "5") router.push("/yonetim/kisi");
            });
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Iptal/index.vue